<div class="edit-customer-address-container">

  <!--  Modal Title-->
  <div fxLayout="row"
  fxLayoutAlign="space-between"
  >
  <h2 fxLayoutAlign="center "
      mat-dialog-title
      [translate]="modalTitle"></h2>

      <button class="close-button" color="primary" [matTooltip]="'shared.labels.close'|translate"
        [mat-dialog-close]="false" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>

  <div class="edit-customer-address-content"
       mat-dialog-content>

    <form class="edit-address-form"
          fxLayout="column"
          fxLayoutGap="8px"
          *ngIf="parentFormGroup"
          [formGroup]="parentFormGroup"
          (ngSubmit)="saveOrUpdateAddress()">


      <!--   Delivery Address   -->
      <ng-container *ngIf="this.isDeliveryAddress else invoiceAddressTemplate ">

        <h3 translate="shared.labels.addressInformation"></h3>

        <!--        Address Information-->
        <btx-address-information-form [group]="parentFormGroup"
                                      [address]="data?.address"></btx-address-information-form>

        <!--        Same Address Billing With Delivery Address-->
        <mat-checkbox [checked]="isInvoiceAddress"
                      [disabled]="data.address?.invoiceAddress && data.editMode"
                      (change)="setSameInvoiceAddressWithDeliveryAddress($event.checked)">
          {{'account.labels.useThisAddress'|translate}}
        </mat-checkbox>


        <!--        Invoice Information-->
        <btx-invoice-information-form *ngIf="isInvoiceAddress"
                                      [parentForm]="parentFormGroup"
                                      [address]="data?.address"></btx-invoice-information-form>


      </ng-container>


      <!--   Invoice Address  -->
      <ng-template #invoiceAddressTemplate>


        <!--        Invoice Information-->
        <btx-invoice-information-form [parentForm]="parentFormGroup"
                                      [address]="data?.address"></btx-invoice-information-form>


        <h3 translate="shared.labels.addressInformation"></h3>

        <!--       Address Information -->
        <btx-address-information-form [group]="parentFormGroup"
                                      [address]="data?.address"></btx-address-information-form>

      </ng-template>


      <!--      Submit Button-->
      <div class="submit-btn save-btn" fxFlex>
        <button mat-raised-button
                type="submit"
                color="primary"
                translate="shared.labels.save"
                fxFlex>
        </button>
      </div>

    </form>
  </div>
</div>
